var scope_0 = require('/home/runner/work/danilucaci.com/danilucaci.com/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/36c3edc9237182e7a4598eaa334cdc3f.js').default;
var scope_1 = require('/home/runner/work/danilucaci.com/danilucaci.com/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5dc36c23f7fa09989318cb033d2eaaff.js').default;
var scope_2 = require('/home/runner/work/danilucaci.com/danilucaci.com/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d7f26cc0979214ea21121eae8e586347.js').default;
var scope_3 = require('/home/runner/work/danilucaci.com/danilucaci.com/packages/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    